import React from 'react';
import {PlanGetSchema} from '../../../../api/DBSchema/Plan';
import BaseAntiSpam from '../../AbstractObjects/GatewayPlan/InnerPages/BaseAntiSpam';

const pageSchema = PlanGetSchema.pages.antiSpam;
const pageId = pageSchema.pageId;

function PlanAntiSpam({
    planObject,
    setPlanData
}) {

    let pageData = planObject[pageId];
    
    return (
        <BaseAntiSpam
            pageData={pageData}
            setObjectData={setPlanData}
        />
    );
}

export default PlanAntiSpam;